import { PUBLIC_BASE_URL } from '@config/game.js'
import { queryString } from '@helpers/utils.js'
import { createClient } from '@services'

const { get } = createClient()

/* API request to fetch Cloud Cooking cook usage for a user */
export async function getCloudCookingCookUsageRequest(userId, gameId) {
  const { data } = await get(
    `${PUBLIC_BASE_URL}/cogs/users/${userId}/cooks/usages${queryString({ game_id: gameId })}`
  )
  return data
}
